module.exports = __webpack_public_path__ + "img/5.a4729084.png";